import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { CustomSelectFieldGroup } from '@components-v2/molecules/CustomSelectFieldGroup'

type Props = {
  placeholder: string
  selectedLocationId: string
  setFieldValue: (value: string) => void
}

export const PrefecturesSelectField: FC<Props> = ({ placeholder, selectedLocationId, setFieldValue }) => {
  const { t } = useTranslation(['global'])

  const onSelect = (value: string) => {
    setFieldValue(value)
  }

  const onUnselect = () => {
    setFieldValue('')
  }

  // TODO: ベタ打ちなので都道府県の取り方考える
  const allItems = [
    { id: '2237', name: t('北海道') },
    { id: '2228', name: t('青森県') },
    { id: '2241', name: t('岩手県') },
    { id: '2249', name: t('宮城県') },
    { id: '2227', name: t('秋田県') },
    { id: '2270', name: t('山形県') },
    { id: '2233', name: t('福島県') },
    { id: '2239', name: t('茨城県') },
    { id: '2264', name: t('栃木県') },
    { id: '2235', name: t('群馬県') },
    { id: '2260', name: t('埼玉県') },
    { id: '2229', name: t('千葉県') },
    { id: '2266', name: t('東京都') },
    { id: '2244', name: t('神奈川県') },
    { id: '2254', name: t('新潟県') },
    { id: '2268', name: t('富山県') },
    { id: '2240', name: t('石川県') },
    { id: '2231', name: t('福井県') },
    { id: '2272', name: t('山梨県') },
    { id: '2251', name: t('長野県') },
    { id: '2234', name: t('岐阜県') },
    { id: '2263', name: t('静岡県') },
    { id: '2226', name: t('愛知県') },
    { id: '2248', name: t('三重県') },
    { id: '2261', name: t('滋賀県') },
    { id: '2247', name: t('京都府') },
    { id: '2258', name: t('大阪府') },
    { id: '2238', name: t('兵庫県') },
    { id: '2253', name: t('奈良県') },
    { id: '2269', name: t('和歌山県') },
    { id: '2267', name: t('鳥取県') },
    { id: '2262', name: t('島根県') },
    { id: '2256', name: t('岡山県') },
    { id: '2236', name: t('広島県') },
    { id: '2271', name: t('山口県') },
    { id: '2265', name: t('徳島県') },
    { id: '2242', name: t('香川県') },
    { id: '2230', name: t('愛媛県') },
    { id: '2245', name: t('高知県') },
    { id: '2232', name: t('福岡県') },
    { id: '2259', name: t('佐賀県') },
    { id: '2252', name: t('長崎県') },
    { id: '2246', name: t('熊本県') },
    { id: '2255', name: t('大分県') },
    { id: '2250', name: t('宮崎県') },
    { id: '2243', name: t('鹿児島県') },
    { id: '2257', name: t('沖縄県') },
  ]

  const selectedItem = allItems.find((item) => selectedLocationId === item.id)

  const selectableItems = allItems.map((item) => ({
    instance: item,
    isSelected: selectedLocationId === item.id,
  }))

  return (
    <CustomSelectFieldGroup
      placeholder={placeholder}
      onSelect={onSelect}
      onUnselect={onUnselect}
      selectedItems={selectedItem ? [selectedItem] : []}
      selectableItems={selectableItems}
      onUnselectAll={onUnselect}
    />
  )
}
